exports.logoWidth="1200";
exports.logoHeight="400";
exports.thumbnailWidth="120";
exports.thumbnailHeight="70";
exports.resultFormat="PNG";